// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__34VFS","notes":"Notes_notes__1eI2l"};